import { AddClient } from '@src/clients/AddClient';
import { ClientsNavigation } from '@src/routing/ClientsNavigation';
import { useNavigate, useParams } from 'react-router-dom';

export const AddAgencyClient = () => {
  const { clientId } = useParams();
  const navigate = useNavigate();

  if (!clientId) {
    throw new Error(
      'AddAgencyClient must be rendered under a route with the agencies clientId provided',
    );
  }

  const navigateToAgencyClients = () =>
    navigate(ClientsNavigation.get.url(clientId, 5));

  return (
    <AddClient
      onAddClientSuccess={navigateToAgencyClients}
      onCancel={navigateToAgencyClients}
      agencyId={clientId}
    />
  );
};
